import * as colors from './colors';
export const border = colors.oriGrey.A400;
export const borderHover = colors.oriGrey[700];
export const borderDisabled = colors.action.disabledBackground;
export const label = colors.text.primary;
export const labelDisabled = colors.blueGreyBackground[100];
export const placeholder = colors.blueGreyBackground[100];
export const contentDisabled = colors.blueGreyBackground[100];
//# sourceMappingURL=textInputColors.js.map